// extracted by mini-css-extract-plugin
export default {"card":"card_card__Ut2Gp","sm":"card_sm__OzabH","lg":"card_lg__0Jv21","xl":"card_xl__E-00G","container":"card_container__IH-yY"};